import styled from "styled-components";
import PageTopTitle from "../../components/shared/PageTopTitle";
import { useDispatch } from "react-redux";
import { useEffect, useRef, useState } from "react";
import { getKYFormSubmissions } from "../../features/kamyoonRoad/kamyoonRoadSlice";
import { useSelector } from "react-redux";
import Pagination from "../../components/shared/Pagination";
import FormSubmissionItem from "../../components/kamyoonRoad/FormSubmissionItem";

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    color: ${({theme}) => theme.mainTextColor};
    

    .top-container{
        display: flex;
        align-items: center;
        margin: 30px;
        margin-bottom: 20px;
        background-color: ${({theme}) => theme.secondaryBgColor};
        border-radius: 30px;
        padding: 15px 20px;
        border: 1px solid ${({theme}) => theme.mainBorderColor};

        h3{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-lg);
            color: ${({theme}) => theme.mainTextColor};
        }
    }
    


    .list{
        
      margin: 0 30px;
      margin-top: 40px;
      display: flex;
      width: 100%;
      flex-direction: column;
      gap: 30px;


        .titles {
            width: calc(100% - 60px);
            display: grid;
            grid-template-columns:1fr 1fr 1fr 1fr 1fr 1fr;
            gap: 15px;
            padding-inline: 10px;
            font-size: var(--font-size-sm);
            font-weight: var(--font-weight-lg);
            text-align: center;
            color: ${({ theme }) => theme.mainTextColor};
        }


    }
  }
`;

const titles = [
    "Şirket/Marka Adı",
    "İlgili Kişi Adı Soyadı",
    "Mail Adresi",
    "Telefon",
    "Adres",
    "Başvuru Tarihi",
]
const KamyoonYollarda = () => {

  const [currentPage, setCurrentPage] = useState(1);

  const {formSubmissionListQuantity, formSubmissionList, isLoadingGetKYFormSubmissions} = useSelector(state=> state.kamyoonRoad)

    const dispatch = useDispatch()

    const topRef = useRef()

      const itemsPerPage = 50;
  const totalPages = Math.ceil(formSubmissionListQuantity / itemsPerPage);

      useEffect(() => {
     if (topRef.current) {
        const rect = topRef.current.getBoundingClientRect();
        const elemTop = rect.top + window.pageYOffset;
        const scrollToPos = elemTop - 300;

        window.scrollTo({
            top: scrollToPos,
            behavior: 'smooth'
        });
        }
    },[currentPage])

    useEffect(() => {

        dispatch(getKYFormSubmissions())
    },[])

  return (
      <Container>
      <div className="wrapper">
        <PageTopTitle title={"Kamyoon Yollarda"} position="sticky" />

        <div className="top-container" ref={topRef}>
            <h3>Sponsorluk Başvuruları {formSubmissionListQuantity > 0 && `(${formSubmissionListQuantity} Başvuru)`}</h3>
        </div>
        
        <div className="list">
            
            <div className="titles">
                {titles.map((item) => (
                    <p>{item}</p>
                ))}
            </div>

            {
                formSubmissionList.map(item => (
                    <FormSubmissionItem item={item}/>
                ))
            }

        </div> 
         <div className="pagination-container">
          {(formSubmissionList || formSubmissionList?.length > 0) && (
            <Pagination
              totalPages={totalPages}
              handleClick={setCurrentPage}
              currentPage={currentPage}
            />
          )}

        </div>
      </div>
    </Container>
  )
}

export default KamyoonYollarda